import React, { useState, useEffect, useRef } from 'react';
import './styles.css'; // Import the styles
import { useTranslation } from 'react-i18next';
import IconUp from "../../assets/images/chevron-up.png";
import IconDown from "../../assets/images/chevron-down.png";
const MultiSelectCleanroom = ({ options, setSelectedCleanroom, handleCloseSelectCleanroom, disabled }) => {
  const [selectedOptionsCleanroom, setSelectedOptionsCleanroom] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);
  const [prevSelectedOptionsCleanroom, setPrevSelectedOptionsCleanroom] = useState(selectedOptionsCleanroom);

  const { t } = useTranslation();
  const selectedCleanroom = JSON.parse(localStorage.getItem('cleanroom'));

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    
    setSelectedOptionsCleanroom((prevSelectedOptionsCleanroom) => {
      if (prevSelectedOptionsCleanroom.includes(option.value)) {
        return prevSelectedOptionsCleanroom.filter((item) => item !== option.value);
      } else {
        return [...prevSelectedOptionsCleanroom, option.value];
      }
    });
    setSelectedCleanroom((prevSelectedOptionsCleanroom) => {
      if (prevSelectedOptionsCleanroom.findIndex((opt)=>
        opt.id== option.id) != -1
      ) {    
        return prevSelectedOptionsCleanroom.filter((item) => 
          item.id !== option.id);
      } else {
        return [...prevSelectedOptionsCleanroom, option];
      }
    });
  };
  useEffect(() => {
    if (selectedCleanroom) {
      if (selectedCleanroom.length > 0) {
        selectedCleanroom.forEach((element) => {
          const option = options.find((opt) => opt.id === element);
          if (option) {
            setSelectedOptionsCleanroom((prevSelectedOptionsCleanroom) => {
              return [...prevSelectedOptionsCleanroom, option.value];
            });
            setPrevSelectedOptionsCleanroom((prevSelectedOptionsCleanroom) => {
              return [...prevSelectedOptionsCleanroom, option.value];
            });
          }
        });
      }
    }
  }, [disabled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        const hasDifference =
          selectedOptionsCleanroom.some((option, index) => option !== prevSelectedOptionsCleanroom[index]) ||
          selectedOptionsCleanroom.length !== prevSelectedOptionsCleanroom.length;

        if (selectedOptionsCleanroom.length > 0) {
          if (selectedCleanroom) {
            if (selectedOptionsCleanroom.length !== selectedCleanroom.length) {
              if (hasDifference) {
                handleCloseSelectCleanroom();
                window.location.reload();
              } else {
                setIsOpen(false);
              }
            } else {
              const optionsChanged = selectedOptionsCleanroom.some(
                (option, index) => option !== prevSelectedOptionsCleanroom[index]
              );
              if (optionsChanged) {
                handleCloseSelectCleanroom();
                window.location.reload();
              } else {
                setIsOpen(false);
              }
            }
          } else {
            if (hasDifference) { 
              handleCloseSelectCleanroom();
              window.location.reload();
            } else {
              setIsOpen(false);
            }
          }
        } else {
          if (hasDifference) {
            handleCloseSelectCleanroom();
            setIsOpen(false);
            window.location.reload();
          }
        }

        setPrevSelectedOptionsCleanroom(selectedOptionsCleanroom);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectedOptionsCleanroom, selectedCleanroom, handleCloseSelectCleanroom, prevSelectedOptionsCleanroom]);

  /* const renderSelectedText = () => {
    const selectedCount = selectedOptionsCleanroom.length;
    if (selectedCount === 0) {
      return t('noneSelected');
    } else if (selectedCount === options.length) {
      return t('allSelected');
    } else {
      return `${selectedCount} ` + t('selected');
    }
  }; */
  const renderSelectedText = () => {
    const selectedCount = selectedOptionsCleanroom.length;
    if (selectedCount === 0) {
      return t('noneSelected');
    }  else if (selectedCount <= 2) {
      return selectedOptionsCleanroom.join(', ');
    }  else if (selectedCount === options.length) {
      return t('allSelected');
    } else {
      return `${selectedCount } `+ t('selected');
    }
  };
  const filteredOptions = options.filter((option) =>
    option.value.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="multi-select-header" ref={dropdownRef} title={selectedOptionsCleanroom.join(',')}>
      <div className="dropdown">
        <button
          className="dropdown-button-header"
          onClick={toggleDropdown}
          style={{
            width: "100%",
            background: "#eff2f7"
          }}
        >
          <span
            className="dropdown-text"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
            }}
          >
            {renderSelectedText()}
          </span>
          {!isOpen ? (
            <img
            src={IconDown}
            alt="Expand"
            style={{  height: '70%' ,marginRight: '4%'}}
          />
          ) : (
            <img
            src={IconUp}
            alt="Collapse"
            style={{  height: '70%' ,marginRight: '4%'}}
          />
          )}
        </button>
        {isOpen && (
          <div
            className="dropdown-menu"
            style={{
              position: "fixed",
              top: dropdownRef.current?.getBoundingClientRect().bottom + "px",
              left: dropdownRef.current?.getBoundingClientRect().left + "px",
              width: dropdownRef.current?.offsetWidth + "px",
              zIndex: 2147483647,
              ...(localStorage.getItem('theme') === 'dark'
                ? { background: '#292929', color: 'white' }
                : {})
            }}
          >
            <div className="search-container">
              <input
              
                type="text"
                placeholder={t('search')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
                style={
                  localStorage.getItem('theme') === 'dark'
                    ? { color: 'white' }
                    : {}
                }
              />
            </div>
            {filteredOptions.map((option) => (
              <div
                key={option.id}
                className="dropdown-item"
                style={
                  localStorage.getItem('theme') === 'dark'
                    ? { color: 'white' }
                    : {}
                }
              >
                <label>
                  <input
                    type="checkbox"
                    checked={selectedOptionsCleanroom.includes(option.value)}
                    onClick={() => handleOptionClick(option)}
                  />
                  {option.value}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelectCleanroom;
